var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import _ from 'lodash';
import URI from 'urijs';
import { HITLBase } from './HITLBase';
export class Sessions extends HITLBase {
    static getSessions(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const route = this.getBaseUrl(options);
            const params = _.omit(options, ['version']);
            return this.request({
                method: 'GET',
                route,
                params,
            });
        });
    }
    static getSessionById(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(options.sessionId).href();
            const params = _.pick(options, ['agentId', 'projection']);
            return this.request({
                method: 'GET',
                route,
                params,
            });
        });
    }
    static searchSessions(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(this.SEARCH_URL).href();
            const params = _.pick(options, ['agentId']);
            const data = _.omit(options, ['agentId', 'version']);
            return this.request({
                method: 'POST',
                route,
                params,
                data,
            });
        });
    }
    static searchSessionsWithContacts(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl)
                .segment(this.SEARCH_WITH_CONTACTS_URL)
                .href();
            const params = _.pick(options, ['agentId']);
            const data = _.omit(options, ['agentId', 'version']);
            return this.request({
                method: 'POST',
                route,
                params,
                data,
            });
        });
    }
    static getQueueSession(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(this.GET_QUEUE_SESSION_URL).href();
            const params = _.pick(options, ['agentId', 'ruleTags']);
            return this.request({
                method: 'GET',
                route,
                params,
            });
        });
    }
    static getSessionInitTriggers(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(this.GET_TRIGGERS_URL).href();
            return this.request({
                method: 'GET',
                route,
            });
        });
    }
    static claimSessionByAgent(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl)
                .segment(options.sessionId)
                .segment(this.CLAIM_URL)
                .href();
            const params = _.pick(options, ['claimBy']);
            const data = _.pick(options, ['params']);
            return this.request({
                method: 'POST',
                route,
                params,
                data,
            });
        });
    }
    static transferToBot(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl)
                .segment(options.sessionId)
                .segment(this.TRANSFER_TO_BOT_URL)
                .href();
            const params = _.pick(options, ['agentId']);
            const data = _.pick(options, ['params']);
            return this.request({
                method: 'POST',
                route,
                params,
                data,
            });
        });
    }
    static startConversation(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(this.START_CONVERSATION_URL).href();
            const params = _.pick(options, ['contactId', 'triggerId']);
            const data = _.pick(options, ['params']);
            return this.request({
                method: 'POST',
                route,
                params,
                data,
            });
        });
    }
    static updateSession(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(options.sessionId).href();
            const data = _.pick(options, ['tags', 'contactId', 'meta']);
            return this.request({
                method: 'PUT',
                route,
                data,
            });
        });
    }
    static createSessions(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const route = this.getBaseUrl(options);
            const data = _.pick(options, ['sessions']);
            return this.request({
                method: 'POST',
                route,
                data,
            });
        });
    }
    static closeSession(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl)
                .segment(options.sessionId)
                .segment(this.CLOSE_URL)
                .href();
            return this.request({
                method: 'POST',
                route,
            });
        });
    }
    static reopenSession(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl)
                .segment(options.sessionId)
                .segment(this.REOPEN_URL)
                .href();
            return this.request({
                method: 'POST',
                route,
            });
        });
    }
    static deleteClosedSession(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.getBaseUrl(options);
            const route = new URI(baseUrl).segment(options.sessionId).href();
            return this.request({
                method: 'DELETE',
                route,
            });
        });
    }
}
Sessions.MODULE_URL = 'sessions';
Sessions.SEARCH_URL = 'search';
Sessions.SEARCH_WITH_CONTACTS_URL = 'search-with-contacts';
Sessions.GET_TRIGGERS_URL = 'helpers/triggers';
Sessions.GET_QUEUE_SESSION_URL = 'helpers/queue';
Sessions.CLAIM_URL = 'claim';
Sessions.TRANSFER_TO_BOT_URL = 'transfer-to-bot';
Sessions.START_CONVERSATION_URL = 'start-conversation';
Sessions.CLOSE_URL = 'close';
Sessions.REOPEN_URL = 'reopen';
//# sourceMappingURL=Sessions.js.map